import { BusinessErrorOption } from './types'

// The bodies the modal offers when errors are picked. They are only a starting point: ROBO-1319
// stores whatever the operator ends up with, verbatim, with no placeholders substituted at send
// time - so the codes have to be spelled out here or the message would name no error at all.
export const defaultSmsMessage = (codes: string[]): string => {
  if (codes.length === 0) return ''

  // Codes only. Descriptions would run past the 160-character cap on the first entry.
  return `There are business errors: Error: ${codes.join(', ')}`
}

export const defaultEmailMessage = (codes: string[], catalog: BusinessErrorOption[]): string => {
  if (codes.length === 0) return ''

  const lines = codes.map((code) => {
    const entry = catalog.find((option) => option.code === code)
    return entry ? `- ${code} ${entry.description}` : `- ${code}`
  })

  return `There are business errors:\n\nError:\n${lines.join('\n')}`
}
